// extracted by mini-css-extract-plugin
module.exports = {"layout":"LandingLayout_layout__ePi3r","layout_opacity":"LandingLayout_layout_opacity__5rdJi","main":"LandingLayout_main__dkz12"};